import { nanoid } from '@reduxjs/toolkit';
import { EventParams, getSessionId } from '.';
import { getClient } from '../../lib/info';

export const loadMetaPixel = (pixelId: string): void => {
  if (!pixelId || (window as any).fbq) return;

  (function (f: any, b, e, v, n?, t?, s?) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = `https://connect.facebook.net/en_US/fbevents.js`;
    s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window as any, document, 'script');

  (window as any).fbq('init', pixelId);
  //   (window as any).fbq('track', 'PageView');
};

export const metaPageView = (
  url: string,
  title: string,
  isModifying = false
) => {
  console.log(`META pageView`, {
    page_location: window.location.href,
    page_path: url,
    title: title,
    isModifying,
  });
  if (typeof (window as any).fbq !== 'function') return;
  const sessionId = getSessionId();
  (window as any).fbq('track', 'PageView', {
    page_location: window.location.href,
    page_path: url,
    session_id: sessionId,
    title: title,
    isModifying,
  });
};

export const trackMetaEvent = ({
  action,
  category,
  label,
  value,
  url,
  isModifying = false,
}: EventParams) => {
  console.log(`META trackEvent`, {
    action,
    event_category: category,
    event_label: label,
    value,
    page_location: window.location.href,
    page_path: url,
    isModifying,
  });
  if (!(window as any).fbq) return;
  const sessionId = getSessionId();

  (window as any).fbq('track', action, {
    event_category: category,
    event_label: label,
    value,
    session_id: sessionId,
    page_location: window.location.href,
    page_path: url,
    isModifying,
  });
};
